'use client'

import { IconMinus, IconPlus } from '@tabler/icons-react'
import clsx from 'clsx'

import styles from './IconChangeQuantity.module.scss'

interface IconChangeQuantityProps {
  onClick: () => void
  className?: string
  disabled: boolean
  isLoading: boolean
  type: 'add' | 'minus'
  ariaLabel?: string
  role?: string
  tabIndex?: number
  ref?: React.RefObject<HTMLButtonElement | null>
  standalone?: boolean
  size?: 'default' | 'large' | 'small'
  algoliaInsightsAttributes?: Record<string, string | number | boolean>
}

export const IconChangeQuantity = ({
  onClick,
  disabled,
  isLoading,
  type,
  className,
  ariaLabel,
  role,
  tabIndex,
  ref,
  standalone = false,
  size = 'default',
  algoliaInsightsAttributes
}: IconChangeQuantityProps) => {
  const ariaLabelText =
    type === 'add'
      ? 'Zwiększ liczbę produktów w koszyku o 1'
      : 'Zmniejsz liczbę produktów w koszyku o 1'

  const icon = type === 'add' ? <IconPlus size={16} /> : <IconMinus size={16} />

  if (standalone) {
    return (
      <button
        ref={ref}
        className={clsx(
          styles.standalone,
          {
            [styles.standaloneSmall]: size === 'small',
            [styles.standaloneLarge]: size === 'large',
            [styles.standaloneDisabled]: disabled
          },
          className
        )}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel || ariaLabelText}
        role={role}
        tabIndex={tabIndex}
        {...algoliaInsightsAttributes}
      >
        <span
          className={clsx(styles.icon, { [styles.loading]: isLoading })}
        >
          {icon}
        </span>
      </button>
    )
  }

  return (
    <button
      ref={ref}
      className={clsx(
        styles.icon,
        { [styles.loading]: isLoading, [styles.disabled]: disabled },
        className
      )}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || ariaLabelText}
      role={role}
      tabIndex={tabIndex}
    >
      {icon}
    </button>
  )
}
